module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "6quality.fb71439b.svg";